export const LOGIN_CHECK = "/";
export const LOGIN = "/login";
export const HOME = "/home";
export const USER_HOME = "/userhome";
export const COMPILE_JS = "/compilejs";
export const CREATE_COURSE = "/create-course";
